<template>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">


            <div class="vx-col sm:w-full md:w-full lg:w-2/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Creación de cuenta</h4>
                  <p>Rellene el siguiente formulario para crear una cuenta.</p>
                </div>
                <register-jwt></register-jwt>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
</template>

<script>
import RegisterJwt from "./registerTypes/RegisterJWT.vue"

export default {
    components: {
      RegisterJwt,
    },
    methods:{
        validatorOnline(){
            if(this.$store.state.AppActiveUser.status)
            this.$router.push('/');
        }
    },
    created(){
        this.validatorOnline();
    }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
